import { render, staticRenderFns } from "./TotalDonation.vue?vue&type=template&id=193012c7"
import script from "./TotalDonation.vue?vue&type=script&lang=js"
export * from "./TotalDonation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports